var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0098 1.5C6.80434 1.5 4.99926 3.30516 4.99926 5.51062V6.0584H6.60539V5.51062C6.60539 4.17316 7.67238 3.10617 9.0098 3.10617C10.3472 3.10617 11.4142 4.17316 11.4142 5.51062V7.70797C10.7067 7.2852 9.88098 7.04156 9.0007 7.04156C6.39836 7.04156 4.27148 9.16844 4.27148 11.7708C4.27148 14.3731 6.39836 16.5 9.0007 16.5C11.603 16.5 13.7299 14.3732 13.7299 11.7708C13.7299 10.861 13.4697 10.0095 13.0204 9.28656V5.51062C13.0204 3.30516 11.2153 1.5 9.0098 1.5ZM9.0007 8.64773C10.735 8.64773 12.1237 10.0365 12.1237 11.7708C12.1237 13.5051 10.735 14.8938 9.0007 14.8938C7.26641 14.8938 5.87766 13.5051 5.87766 11.7708C5.87766 10.0364 7.26641 8.64773 9.0007 8.64773ZM9.01613 10.46C8.2843 10.46 7.69105 11.0532 7.69105 11.785C7.69105 12.5169 8.2843 13.1101 9.01613 13.1101C9.74797 13.1101 10.3412 12.5169 10.3412 11.785C10.3412 11.0532 9.74793 10.46 9.01613 10.46Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.776b680d0b96c56163cc792ea82a283f.svg";
export { ForwardRef as ReactComponent };